import axios from "axios";
import { base_url } from "../../utils/axiosConfig";

const trackVisit = async () => {
  const response = await axios.get(`${base_url}visitor/track`, {
    withCredentials: false,
  });
  return response.data;
};

export const trackService = {
  trackVisit,
};
